//打包运行环境
let VUE_APP_ENV_TYPE = 'production';
VUE_APP_ENV_TYPE = process.env.VUE_APP_ENV_TYPE ? process.env.VUE_APP_ENV_TYPE.trim() : VUE_APP_ENV_TYPE;
//dev环境
let VUE_APP_DEV_TYPE = process.env.VUE_APP_DEV_TYPE ? process.env.VUE_APP_DEV_TYPE.trim() : '';


let wwwhost = ''
let apihost = ''
let iohost = ''
let env_version = 'develop'

if(VUE_APP_ENV_TYPE === 'development'){
  if(VUE_APP_DEV_TYPE === 'dev'){
    wwwhost = '/devHost'
    apihost = '/devApi'
  }else if(VUE_APP_DEV_TYPE === 'test'){
    wwwhost = '/testHost'
    apihost = '/testApi'
  }else if(VUE_APP_DEV_TYPE === 'staging'){
    wwwhost = '/stagingHost'
    apihost = '/stagingApi'
    iohost = '/stagingIoApi'
  }else{
    wwwhost = '/wwwHost'
    apihost = '/wwwApi'
    iohost = '/ioApi'
  }
}else if(VUE_APP_ENV_TYPE === 'dev'){ //dev
  wwwhost = 'https://dev-test1.wondercv.cn'
  apihost = 'https://dev-api.wondercv.cn'
// }else if(VUE_APP_ENV_TYPE === 'test'){ //test
//   host = 'https://dev-interface.wondercv.cn'
//   wwwhost = 'https://dev-test1.wondercv.cn'
//   apihost = 'https://dev-interface.wondercv.cn/cv'
//   authhost = 'https://dev-interface.wondercv.cn/auth'
//   wxhost = 'https://dev-wx.wondercv.cn'
}else if(VUE_APP_ENV_TYPE === 'staging'){ //staging
  wwwhost = 'https://www.wondercv.cn'
  apihost = 'https://api.wondercv.cn'
  iohost = 'https://staging-io.wondercv.cn'
  env_version = 'trial'
}else{ //prod
  wwwhost = 'https://www.wondercv.com'
  apihost = 'https://api.wondercv.com'
  iohost = 'https://io.wondercv.cn'
  env_version = 'release'
}

export const WWWHOST = wwwhost;
export const APIHOST = apihost;
export const IOHOST = iohost;
export const ENV_VERSION = env_version;